export default () => {
  const $partners = $('.partners');

  if ($partners.length === 0) {
    return;
  }

  $partners.slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="slick-prev pull-left">Назад</button>',
    nextArrow: '<button type="button" class="slick-next pull-right">Вперед</button>',
    appendArrows: $partners.closest('.slider-theme').find('.slider-theme__arrows'),
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });
};
